<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="toc"><a id="pagevi"></a><a id="pagevii"></a>Contents</h1>
<p class="toc"><a href="#/OEBPS/cvi.htm">Cover</a></p>
<p class="toc" id="also"><a href="#/OEBPS/also.htm">Also by Mark Bowden</a></p>
<p class="toc" id="tp"><a href="#/OEBPS/tp.htm">Title Page</a></p>
<p class="toc" id="cop"><a href="#/OEBPS/cop.htm">Copyright</a></p>
<p class="toc" id="ded"><a href="#/OEBPS/ded.htm">Dedication</a></p>
<p class="toc" id="pro"><a href="#/OEBPS/pro.htm">Prologue</a></p>
<p class="toc" id="p01"><a href="#/OEBPS/p01.htm">The Rise of <em>El Doctor</em></a></p>
<p class="toc1" id="p01_c01"><a href="#/OEBPS/p01_c01.htm#p01_c01">Chapter One</a></p>
<p class="toc1" id="p01_c02"><a href="#/OEBPS/p01_c02.htm#p01_c02">Chapter Two</a></p>
<p class="toc1" id="p01_c03"><a href="#/OEBPS/p01_c03.htm#p01_c03">Chapter Three</a></p>
<p class="toc1" id="p01_c04"><a href="#/OEBPS/p01_c04.htm#p01_c04">Chapter Four</a></p>
<p class="toc1" id="p01_c05"><a href="#/OEBPS/p01_c05.htm#p01_c05">Chapter Five</a></p>
<p class="toc" id="p02"><a href="#/OEBPS/p02.htm">The First War</a></p>
<p class="toc1" id="p02_c01"><a href="#/OEBPS/p02_c01.htm#p02_c01">Chapter One</a></p>
<p class="toc1" id="p02_c02"><a href="#/OEBPS/p02_c02.htm#p02_c02">Chapter Two</a></p>
<p class="toc1" id="p02_c03"><a href="#/OEBPS/p02_c03.htm#p02_c03">Chapter Three</a></p>
<p class="toc1" id="p02_c04"><a href="#/OEBPS/p02_c04.htm#p02_c04">Chapter Four</a></p>
<p class="toc1" id="p02_c05"><a href="#/OEBPS/p02_c05.htm#p02_c05">Chapter Five</a></p>
<p class="toc" id="p03"><a href="#/OEBPS/p03.htm">Imprisonment and Escape</a></p>
<p class="toc1" id="p03_c01"><a href="#/OEBPS/p03_c01.htm#p03_c01">Chapter One</a></p>
<p class="toc1" id="p03_c02"><a href="#/OEBPS/p03_c02.htm#p03_c02">Chapter Two</a></p>
<p class="toc1" id="p03_c03"><a href="#/OEBPS/p03_c03.htm#p03_c03">Chapter Three</a></p>
<p class="toc1" id="p03_c04"><a href="#/OEBPS/p03_c04.htm#p03_c04">Chapter Four</a></p>
<p class="toc1" id="p03_c05"><a href="#/OEBPS/p03_c05.htm#p03_c05">Chapter Five</a></p>
<p class="toc1" id="p03_c06"><a href="#/OEBPS/p03_c06.htm#p03_c06">Chapter Six</a></p>
<p class="toc1" id="p03_c07"><a href="#/OEBPS/p03_c07.htm#p03_c07">Chapter Seven</a></p>
<p class="toc1" id="p03_c08"><a href="#/OEBPS/p03_c08.htm#p03_c08">Chapter Eight</a></p>
<p class="toc1" id="p03_c09"><a href="#/OEBPS/p03_c09.htm#p03_c09">Chapter Nine</a></p>
<p class="toc1" id="p03_c10"><a href="#/OEBPS/p03_c10.htm#p03_c10">Chapter Ten</a></p>
<p class="toc1" id="p03_c11"><a href="#/OEBPS/p03_c11.htm#p03_c11">Chapter Eleven</a></p>
<p class="toc" id="p04"><a href="#/OEBPS/p04.htm"><em>Los Pepes</em></a></p>
<p class="toc1" id="p04_c01"><a href="#/OEBPS/p04_c01.htm#p04_c01">Chapter One</a></p>
<p class="toc1" id="p04_c02"><a href="#/OEBPS/p04_c02.htm#p04_c02">Chapter Two</a></p>
<p class="toc1" id="p04_c03"><a href="#/OEBPS/p04_c03.htm#p04_c03">Chapter Three</a></p>
<p class="toc" id="p05"><a href="#/OEBPS/p05.htm">The Kill</a></p>
<p class="toc1" id="p05_c01"><a href="#/OEBPS/p05_c01.htm#p05_c01">Chapter One</a></p>
<p class="toc1" id="p05_c02"><a href="#/OEBPS/p05_c02.htm#p05_c02">Chapter Two</a></p>
<p class="toc1" id="p05_c03"><a href="#/OEBPS/p05_c03.htm#p05_c03">Chapter Three</a></p>
<p class="toc1" id="p05_c04"><a href="#/OEBPS/p05_c04.htm#p05_c04">Chapter Four</a></p>
<p class="toc1" id="p05_c05"><a href="#/OEBPS/p05_c05.htm#p05_c05">Chapter Five</a></p>
<p class="toc1" id="p05_c06"><a href="#/OEBPS/p05_c06.htm#p05_c06">Chapter Six</a></p>
<p class="toc1" id="p05_c07"><a href="#/OEBPS/p05_c07.htm#p05_c07">Chapter Seven</a></p>
<p class="toc" id="p06"><a href="#/OEBPS/p06.htm">Aftermath</a></p>
<p class="toc1" id="sources"><a href="#/OEBPS/sources.htm">Sources</a></p>
<p class="toc1" id="ack"><a href="#/OEBPS/ack.htm">Acknowledgments</a></p>
<p class="toc1" id="index"><a href="#/OEBPS/index.htm">Index</a></p>
<p class="toc1"><a href="#/OEBPS/back.htm">Back Cover</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7705aed0